export default __webpack_public_path__ + "static/propertybanner-mobile-79ef3c70ae855cb1ce3f3ef091bfb7d4.jpg";